import { render, staticRenderFns } from "./CompanyWhiteLabelUpload.vue?vue&type=template&id=ad2e2442"
import script from "./CompanyWhiteLabelUpload.vue?vue&type=script&lang=js"
export * from "./CompanyWhiteLabelUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports